export const MUTATION_KEYS = {
    buyMicromorgiPackageV3: 'buyMicromorgiPackageV3',
    send_micromorgi: 'send-micromorgi',
    send_request_to_get_ultimate_status: 'send-request-to-get-ultimate-status'
}

export const QUERY_KEYS = {
    micromorgiPackagesV3: 'micromorgiPackagesV3',
    micromorgi_transactions: 'micromorgi-transactions',
    animations: 'animations',
    current_animation: 'current-animation'
}
